/**
 * https://wbs2017.atlassian.net/wiki/spaces/EMIOT/pages/1461452895/EMIOT+analytic+events
 */
export default class Tracking {

  /**
   * @param {Vue.instance} component
   * @param {Function} configFn
   * @param {String} name
   */
  constructor(component, configFn, name) {
    this.$store = component.$store;
    this.config = configFn();
    this.uid = `${name}-${(new Date()).getTime()}-${Math.random().toString().substr(2)}`;
  }

  /**
   * attach tracking instance to a html dom, so native js can access it
   * @return {Tracking}
   */
  attachInstance() {
    document.getElementById(this.uid).vueTracking = this;
    return this;
  }

  /**
   * @return {string}
   */
  getUID() {
    return this.uid;
  }

  /**
   *
   * @param {String} event_type
   * @param {Object} attributes
   * @return {*}
   */
  logEvent(event_type, attributes = {}) {
    //1. use config as default settings
    let eventProperties = Object.assign({}, this.config[event_type]);

    //2. require attributes to match
    if(eventProperties.attributes) {
      eventProperties.attributes = Object.fromEntries(
        Object.entries(eventProperties.attributes).map(([currentKey, defaultValue]) => {
          let submittedValue = attributes?.[currentKey], value;

          if (typeof defaultValue === 'function') {
            value = defaultValue(submittedValue);
          }
          else if (submittedValue !== undefined) {
            value = submittedValue;
          }
          else {
            console.error('Require supply attributes', {event_type, attributes, 'missing': currentKey});
            value = null;
          }

          return [currentKey, value];
        })
      );
    }

    return this.$store.getters.amplitudeClient.logEvent(event_type, eventProperties);
  }

}